<template>
  <div class="container">
    <img src="./../image/logo.png" class="logo-image" />
    <div class="header-link_list">
      <router-link :to="{ name: 'home' }" class="link-list_item"
        >课件中心</router-link
      >
      <router-link :to="{ name: 'works_center' }" class="link-list_item"
        >作品中心</router-link
      >
      <router-link :to="{ name: 'userTheLayout' }" class="link-list_item"
        >个人中心</router-link
      >
    </div>
    <el-dropdown style="height: 48px" @command="handleCommand">
      <div class="user-info">
        <img v-if="userAvatar" class="user-avatar" :src="userAvatar" />
        <span v-if="userData.name" class="nick_name">{{ userData.name }}</span>
        <i class="el-icon-arrow-down"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-edit" command="show"
          >修改密码</el-dropdown-item
        >
        <el-dropdown-item icon="el-icon-video-pause" command="quit"
          >退出</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog title="修改密码" :visible.sync="editShow" width="550px">
      <span>
        <el-form
          label-position="right"
          label-width="110px"
          :model="passwordForm"
          ref="passwordForm"
          :rules="rules"
        >
          <el-form-item style="width: 90%" label="旧密码" prop="old_password">
            <el-input
              v-model="passwordForm.old_password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 90%" label="新密码" prop="one_password">
            <el-input
              v-model="passwordForm.one_password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item style="width: 90%" label="新密码" prop="two_password">
            <el-input
              v-model="passwordForm.two_password"
              show-password
            ></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="medium">取 消</el-button>
        <el-button type="primary" @click="submit" size="medium"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import userService from "@/global/service/user";
import Cookie from "js-cookie";
export default {
  data() {
    return {
      userAvatar:
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "change" }
        ],
        one_password: [
          { required: true, message: "请输入新密码", trigger: "change" }
        ],
        two_password: [
          { required: true, message: "请输入新密码", trigger: "change" }
        ]
      },
      passwordForm: {
        old_password: "",
        one_password: "",
        two_password: ""
      },
      editShow: false,
      userData: {}
    };
  },
  created() {},
  methods: {
    show() {
      this.editShow = true;
    },
    submit() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          if (
            this.passwordForm.one_password !== this.passwordForm.two_password
          ) {
            return this.$message.error("第一次新密码与第二次新密码必须相同");
          }
          const params = {
            old_password: this.passwordForm.old_password,
            new_password: this.passwordForm.one_password,
            new_password_confirmation: this.passwordForm.two_password
          };
          userService
            .setPassword(params)
            .then(() => {
              this.$message.success("修改成功");
              for (let key in this.passwordForm) {
                this.passwordForm[key] = "";
              }
              this.$refs.passwordForm.resetFields();
            })
            .finally(() => {
              this.editShow = false;
            });
        }
      });
    },
    cancel() {
      this.passwordForm = {
        old_password: "",
        one_password: "",
        two_password: ""
      };
      this.editShow = false;
    },
    handleCommand(command) {
      this[command]();
    },
    quit() {
      Cookie.remove("shiguang_token", {
        domain: process.env.VUE_APP_DOMAIN
      });
      window.location.reload();
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 70%;
  min-width: 960px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  .logo-image {
    height: 48px;
    margin-right: 70px;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
  .header-link_list {
    flex: 1;
    display: flex;
    align-self: flex-end;
    padding-bottom: 10px;
    .link-list_item {
      text-decoration: none;
      color: #313033;
      margin-right: 30px;
      position: relative;
      font-size: 16px;
      font-weight: 400;
      flex-shrink: 0;
      &:hover {
        font-weight: 500;
        &:after {
          content: "";
          position: absolute;
          width: 110%;
          height: 2px;
          background-color: #f90;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      &.router-link-active {
        font-weight: 500;
        &:after {
          content: "";
          position: absolute;
          width: 110%;
          height: 2px;
          background-color: #f90;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    padding: 0 10px;
    height: 100%;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
    .user-avatar {
      margin: 0 8px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    .nick_name {
      margin-right: 8px;
      font-size: 12px;
      vertical-align: middle;
    }
  }
}
</style>
